import Home from './pages/Home';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import AppStatistics from './pages/AppStatistics';
import Reports from './pages/Reports';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import LiveChat from './pages/LiveChat';
import NrtOrders from './pages/NrtOrders';

const routes = [
    {
        path: '/',
        name: 'Home',
        icon: 'home',
        element: Home,
        hidden: true,
        hiddenOnDash: true
    },
    {
        path: '/forgotPassword',
        name: 'Forgot Password',
        element: ForgotPassword,
        hidden: true,
        hiddenOnDash: true
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        icon: 'chart-tree-map',
        element: Dashboard,
        roles: ['Admin', 'Service Lead', 'NRT Approval', 'NRT Deliveries', 'Reporting', 'Chat'],
        hiddenOnDash: true
    },
    {
        path: '/appStats',
        name: 'App Statistics',
        icon: 'chart-sine',
        element: AppStatistics,
        roles: ['Admin', 'Service Lead', 'Reporting']
    },
    {
        path: '/reports',
        name: 'Reports',
        icon: 'chart-pie',
        element: Reports,
        roles: ['Admin', 'Service Lead', 'Reporting']
    },
    {
        path: '/nrtOrders',
        name: 'NRT Orders',
        icon: 'inhaler',
        element: NrtOrders,
        roles: ['Admin', 'Service Lead', 'NRT Approval', 'NRT Deliveries']
    },
    {
        path: '/liveChat',
        name: 'Live Chat',
        icon: 'headset',
        element: LiveChat,
        roles: ['Admin', 'Service Lead', 'Chat']
    },
    {
        path: '/admin',
        name: 'Admin',
        icon: 'gear',
        element: Admin,
        roles: ['Admin', 'Service Lead', 'NRT Deliveries'],
    },
    {
        path: '*',
        name: '404 Not Found',
        element: NotFound,
        hidden: true,
        hiddenOnDash: true
    }
];

export default routes;
